import React, { useEffect, useRef } from "react";
import TextField from '@material-ui/core/TextField';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { indigo } from "@material-ui/core/colors";
import VMasker from 'vanilla-masker';
import { Checkbox, Chip, Input, ListItemText, MenuItem, Select, Typography } from '@material-ui/core';
import { unoTheme, myInput, myLabelInput } from "../../assets/styles/unoTheme";
import InputBase from '@material-ui/core/InputBase';
import NativeSelect from '@material-ui/core/NativeSelect';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'

    },
    disabled: {
        background: '#eeeeee'
    },
    withRightBtn: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '4px 0px 0px 4px !important'
        },
    },
    center: {

        '& input': {
            textAlign: 'center !important'
        }

    },
    left: {

        '& input': {
            textAlign: 'left !important'
        }

    },
    right: {

        '& input': {
            textAlign: 'right !important'
        }

    },
    label: myLabelInput,
    marginTop: {
        marginTop: '5px'
    },
    hiddenOption: {
        display: 'none',
    },

    //Só o modo multiple. Os chips já quebram linha no renderValue, mas ficavam escondidos a
    //partir do terceiro por causa de duas coisas somadas: o `height` fixo do BootstrapInput e o
    //`overflow: hidden` + `white-space: nowrap` que o MUI aplica em .MuiSelect-selectMenu.
    //A altura passa a acompanhar o conteúdo, com o height antigo virando piso.
    multipleInput: {
        '& .MuiInputBase-input': {
            height: 'auto',
            minHeight: unoTheme.heightInput,
            //O .MuiInputBase-input do MUI é content-box, então o padding vertical entra por fora da
            //altura: para o campo ficar do mesmo tamanho dos demais, ele precisa bater com o
            //padding do BootstrapInput (6px), e não com um valor menor.
            paddingTop: '6px',
            paddingBottom: '6px',
            overflow: 'visible',
            //Sem isso o .MuiSelect-selectMenu corta os chips numa linha só.
            //O container dos chips fica em bloco de propósito: como item flex ele teria
            //min-width auto e cresceria em vez de quebrar linha.
            whiteSpace: 'normal',
        },
    },

    errorSelect: {
        "& .MuiNativeSelect-root": {
            border: 'solid 1px red',
        },

        '& .Mui-error': {
            marginLeft: '0px',
            fontSize: '0.75rem',
            marginTop: '3px',
            textAlign: 'left',
            fontWeight: '400',
            lineHeight: '1.66',
            color: '#f44336',
        },

        '& .MuiTypography-root': {
            color: 'red',
        }

    },

    warningSelect: {
        "& .MuiNativeSelect-root": {
            border: 'solid 1px #f59e0b',
        },

        '& .MuiTypography-root': {
            color: '#b45309',
        }
    },

    warningText: {
        marginLeft: '0px',
        fontSize: '0.75rem',
        marginTop: '3px',
        textAlign: 'left',
        fontWeight: '400',
        lineHeight: '1.66',
        color: '#b45309',
    },

    multiplePlaceholder: {
        color: unoTheme.secondaryColor,
        //Como span inline o texto formava uma linha de 22px encostada no topo da caixa de 26px.
        //Em bloco, com line-height igual à altura do campo, ele fica centralizado e à esquerda,
        //no mesmo lugar em que o select nativo desenha o texto dele.
        display: 'block',
        textAlign: 'left',
        lineHeight: unoTheme.heightInput,
        //multipleInput solta o white-space para os chips quebrarem linha; o placeholder não deve
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    rawSelect: {

        '& .MuiNativeSelect-select.MuiNativeSelect-select': {
            paddingLeft: '5px',
            height: '16px',
            background: 'none',
            lineHeight: '15px',
            //border: 'none',
            boxShadow: 'none !important'
        }
    }


}));

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        height: unoTheme.heightInput,
        borderRadius: 6,
        position: 'relative',
        backgroundColor: unoTheme.defaultInputBackground,
        border: '1px solid #ced4da',
        fontSize: 16,
        lineHeight: '22px',
        padding: '6px 26px 6px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const BootstrapVerySmallInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        //width: '70px',
        borderRadius: 6,
        position: 'relative',
        backgroundColor: unoTheme.defaultInputBackground,
        border: '1px solid #ced4da',
        fontSize: 12,
        padding: '0px 26px 0px 12px',
        lineHeight: '18px',
        height: '26.250px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

export default function MySelect(props) {

    const {
        multiple,
        outerlabel,
        options,
        verysmall,
        initblank,
        helperText,
        validator,
        warning,
        warningText,
        rawSelect,
        customWidth,
        valuesMultiple,
        optionsMultiple,
        placeholder,
        maxchips
    } = props

    const classes = useStyles();
    const inputRef = useRef();

    function renderOptions() {

        //console.log("RENDER OPTIONS")
        options.unshift(<option key={'hidden-opt'} className={classes.hiddenOption} selected></option>)
        return (
            options
        )
    }

    return (
        <div className={[classes.root, validator ? classes.errorSelect : (warning ? classes.warningSelect : "")].join(' ')} style={{ width: customWidth ? customWidth : "auto" }}>

            {
                outerlabel && outerlabel != "" ?
                    <Typography
                        className={classes.label}>
                        {outerlabel}
                    </Typography> : null
            }

            {
                multiple ?
                    <Select
                        multiple
                        //Sem displayEmpty o MUI nem chama o renderValue com a seleção vazia, e o
                        //placeholder nunca apareceria
                        displayEmpty={placeholder ? true : undefined}
                        value={valuesMultiple}
                        onChange={(e) => props.onChange(e.target.value)}
                        className={[
                            outerlabel != undefined && outerlabel !== "" ? classes.marginTop : "",
                            rawSelect ? classes.rawSelect : "",
                            classes.multipleInput,
                        ].join(" ")}
                        input={verysmall ? <BootstrapVerySmallInput /> : <BootstrapInput />} // troque pelo seu BootstrapInput / BootstrapVerySmallInput
                        renderValue={(selected) => {

                            //Sem isto o campo fica completamente em branco enquanto nada está
                            //selecionado, sem dizer ao que ele se refere
                            if (!selected || !selected.length) {
                                return <span className={classes.multiplePlaceholder}>{placeholder ? placeholder : ""}</span>
                            }

                            //maxchips segura a altura do campo: onde o layout não pode crescer
                            //(um header de altura fixa, por exemplo) o excedente vira "+N"
                            const shownValues = maxchips ? selected.slice(0, maxchips) : selected;
                            const hiddenCount = selected.length - shownValues.length;

                            return (
                                <div style={{ display: "flex", alignItems: "center", flexWrap: maxchips ? "nowrap" : "wrap", gap: 6 }}>
                                    {(shownValues).map((v) => {
                                        const opt = optionsMultiple.find((o) => o.value === v);
                                        return <Chip key={String(v)} label={opt?.label ?? String(v)} size="small" />;
                                    })}
                                    {hiddenCount > 0 ?
                                        <Chip key={'more-selected'} label={'+' + hiddenCount} size="small" /> : null}
                                </div>
                            )
                        }}
                        MenuProps={{
                            PaperProps: { style: { maxHeight: 320 } },
                        }}
                    >
                        {initblank && (
                            <MenuItem disabled value="">
                                Selecione...
                            </MenuItem>
                        )}

                        {optionsMultiple.map((opt) => (
                            <MenuItem key={opt.value + "-" + opt.label} value={opt.value}>
                                <Checkbox checked={valuesMultiple.indexOf(opt.value) > -1} />
                                <ListItemText primary={opt.label} />
                            </MenuItem>
                        ))}
                    </Select>
                    :
                    <NativeSelect

                        ref={inputRef}
                        className={[
                            outerlabel != undefined
                                && outerlabel != "" ? classes.marginTop : "",
                            rawSelect ? classes.rawSelect : ''].join(' ')}
                        {...props}
                        input={verysmall ? <BootstrapVerySmallInput /> : <BootstrapInput />}>
                        {initblank ? renderOptions() : options}
                    </NativeSelect>
            }


            {
                validator ?
                    <p class="Mui-error">{helperText}</p>
                    : null
            }

            {
                !validator && warning && warningText ?
                    <p className={classes.warningText}>{warningText}</p>
                    : null
            }


        </div>


    )
}